import { render, staticRenderFns } from "./InspectionDocumentComponent.vue?vue&type=template&id=2620c2d6&scoped=true"
import script from "./InspectionDocumentComponent.vue?vue&type=script&lang=js"
export * from "./InspectionDocumentComponent.vue?vue&type=script&lang=js"
import style0 from "./InspectionDocumentComponent.vue?vue&type=style&index=0&id=2620c2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620c2d6",
  null
  
)

export default component.exports